<template>
    <a
        href="#"
        v-bind="$attrs"
        data-spec-class="logout-link"
        @click.prevent="onLogout"
    >
        <slot>{{ t('actions.logout') }}</slot>
    </a>

    <Teleport to="body">
        <form
            ref="logoutFormRef"
            method="POST"
            :action="`${baseUrl}/logout${redirectParams}`"
            role="none"
        >
            <BaseFieldCsrf />
        </form>
    </Teleport>
</template>

<script setup lang="ts">
import { ref, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const logoutFormRef = ref(null);
const baseUrl = window.location.origin;

defineProps({
    redirectParams: { type: String, default: '' },
});

const onLogout = () => {
    logoutFormRef.value.submit();
};
</script>
